import { AgreementName, BaseType } from '@dev-fast/types';

export interface AgreementsStateModel {
  items: BaseType<number, Partial<Record<AgreementName, boolean>>>[];
}

export const AGREEMENTS_INITIAL_STATE: AgreementsStateModel = {
  items: [],
};
